import React from "react";

import BottomButtonContainer from "@/components/shared/ui/BottomButtonContainer/BottomButtonContainer";
import { ArticleSection } from "@/types/articleEntryData.types";
import { FILL_IN_TABLE_KEY } from "@FillInTableContainer/shared/constants/fillInTableKey";

import ClinicalTrialsBottomButtonContainer from "./components/ClinicalTrialsBottomButtonContainer/ClinicalTrialsBottomButtonContainer";
import ClinicalTrialStatusBottomButtonContainer from "./components/ClinicalTrialStatusBottomButtonContainer/ClinicalTrialStatusBottomButtonContainer";
import CompanyWebsiteVariousPagesBottomButtonContainer from "./components/CompanyWebsiteVariousPagesBottomButtonContainer/CompanyWebsiteVariousPagesBottomButtonContainer";
import ConferenceScheduleBottomButtonContainer from "./components/ConferenceScheduleBottomButtonContainer/ConferenceScheduleBottomButtonContainer";
import CTGBottomButtonContainer from "./components/CTGBottomButtonContainer/CTGBottomButtonContainer";
import DealFilingBottomButtonContainer from "./components/DealFilingBottomButtonContainer/DealFilingBottomButtonContainer";
import DealsBottomButtonContainer from "./components/DealsBottomButtonContainer/DealsBottomButtonContainer";
import ExpeditedProgramBottomButtonContainer from "./components/ExpeditedProgramBottomButtonContainer/ExpeditedProgramBottomButtonContainer";
import FundingFilingBottomButtonContainer from "./components/FundingFilingBottomButtonContainer/FundingFilingBottomButtonContainer";
import PublicationBottomButtonContainer from "./components/PublicationBottomButtonContainer/PublicationBottomButtonContainer";
import PublicationJournalBottomButtonContainer from "./components/PublicationJournalBottomButtonContainer/PublicationJournalBottomButtonContainer";
import RegulatoryBottomButtonContainer from "./components/RegulatoryBottomButtonContainer/RegulatoryBottomButtonContainer";
import VentureCapitalBottomButtonContainer from "./components/VentureCapitalBottomButtonContainer/VentureCapitalBottomButtonContainer";
import AIAdvisorBottomSheet from "../AIAdvisorBottomSheet/AIAdvisorBottomSheet";

interface Props {
  articleSection: ArticleSection;
}

const FillInTableBottomButtonContainer = ({ articleSection }: Props) => {
  const TABLE_CREATOR_CONTAINER = {
    [FILL_IN_TABLE_KEY.ClinicalTrials]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <ClinicalTrialsBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.ClinicalTrialStatus]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <ClinicalTrialStatusBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.CompanyWebsiteVariousPages]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <CompanyWebsiteVariousPagesBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.Regulatory]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <RegulatoryBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.Deals]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <DealsBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.DealLaSc]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <DealsBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.DealFiling]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <DealFilingBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.ExpeditedProgram]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <ExpeditedProgramBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.VentureCapital]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <VentureCapitalBottomButtonContainer />
      </BottomButtonContainer>
    ),

    [FILL_IN_TABLE_KEY.FundingFiling]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <FundingFilingBottomButtonContainer />
      </BottomButtonContainer>
    ),
    CTG: (
      <BottomButtonContainer isSticky>
        <CTGBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.Publication]: (
      <BottomButtonContainer isSticky>
        <PublicationBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.PublicationJournal]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <PublicationJournalBottomButtonContainer />
      </BottomButtonContainer>
    ),
    [FILL_IN_TABLE_KEY.ConferenceSchedule]: (
      <BottomButtonContainer isSticky>
        <AIAdvisorBottomSheet />
        <ConferenceScheduleBottomButtonContainer />
      </BottomButtonContainer>
    ),
  } satisfies Record<string, React.ReactElement>;

  return TABLE_CREATOR_CONTAINER[articleSection];
};

export default FillInTableBottomButtonContainer;
